<template>
  <router-view></router-view>
  <BaseConfirm />
  <template v-if="canShowRibbon">
    <EnvironmentRibbon />
  </template>
  <v-alert v-if="alertStore.current.visible"
    class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-auto max-w-lg z-50 shadow-lg rounded-lg px-6 py-4 text-white"
    :type="alertStore.current.type" :icon="alertStore.current.icon" :style="alertStyles" border elevation="10">
    {{ alertStore.current.message }}
  </v-alert>
</template>

<script setup>
import { computed, onMounted, watch } from "vue";
import BaseConfirm from "@/components/common/BaseConfirm.vue";
import EnvironmentRibbon from "@/components/common/EnvironmentRibbon.vue";
import { useAccount } from "@/store/account";
import { useAlert } from "@/store/alert";

const alertStore = useAlert();
const accountStore = useAccount();

const alertStyles = computed(() => {
  switch (alertStore.current.type) {
    case "success":
      return { backgroundColor: "#A5D6A7", borderColor: "#388E3C" };
    case "error":
      return { backgroundColor: "#E57373", borderColor: "#C62828" };
    case "warning":
      return { backgroundColor: "#FFF59D", borderColor: "#FBC02D", color: "#000" };
    case "info":
    default:
      return { backgroundColor: "#90CAF9", borderColor: "#1976D2" };
  }
});

onMounted(() => {
  var _iub = [];

  if (accountStore.current.privacy_cookie_code) {
    console.log("Privacy cookie code: ", accountStore.current.privacy_cookie_code);
    _iub.csConfiguration = { "askConsentAtCookiePolicyUpdate": true, "countryDetection": true, "enableLgpd": true, "enableTcf": true, "enableUspr": true, "floatingPreferencesButtonDisplay": "bottom-right", "googleAdditionalConsentMode": true, "lgpdAppliesGlobally": false, "perPurposeConsent": true, "siteId": accountStore.current.privacy_cookie_code, "tcfPurposes": { "2": "consent_only", "3": "consent_only", "4": "consent_only", "5": "consent_only", "6": "consent_only", "7": "consent_only", "8": "consent_only", "9": "consent_only", "10": "consent_only" }, "whitelabel": false, "cookiePolicyId": accountStore.current.privacy_cookie_code, "lang": "it", "banner": { "acceptButtonDisplay": true, "closeButtonDisplay": false, "customizeButtonDisplay": true, "explicitWithdrawal": true, "listPurposes": true, "position": "float-top-center", "rejectButtonDisplay": true, "showPurposesToggles": true } };
  } else {
    _iub.csConfiguration = { "askConsentAtCookiePolicyUpdate": true, "countryDetection": true, "enableLgpd": true, "enableTcf": true, "enableUspr": true, "floatingPreferencesButtonDisplay": "bottom-right", "googleAdditionalConsentMode": true, "lgpdAppliesGlobally": false, "perPurposeConsent": true, "siteId": 77075135, "tcfPurposes": { "2": "consent_only", "3": "consent_only", "4": "consent_only", "5": "consent_only", "6": "consent_only", "7": "consent_only", "8": "consent_only", "9": "consent_only", "10": "consent_only" }, "whitelabel": false, "cookiePolicyId": 77075135, "lang": "it", "banner": { "acceptButtonDisplay": true, "closeButtonDisplay": false, "customizeButtonDisplay": true, "explicitWithdrawal": true, "listPurposes": true, "position": "float-top-center", "rejectButtonDisplay": true, "showPurposesToggles": true } };
  }
  window._iub = _iub;

  const scripts = [
    "//cdn.iubenda.com/cs/tcf/stub-v2.js",
    "//cdn.iubenda.com/cs/tcf/safe-tcf-v2.js",
    "//cdn.iubenda.com/cs/gpp/stub.js",
    "//cdn.iubenda.com/cs/iubenda_cs.js"
  ];

  //Itera sugli script e li aggiunge alla pagina
  scripts.forEach(src => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = false;
    document.head.appendChild(script);
  });
  //Aggiorna il titolo e la descrizione dinamicamente
  updateTitleAndDescription(accountStore.current.name, accountStore.current.description);
});

const canShowRibbon = computed(() => {
  return ['development', 'staging'].indexOf(import.meta.env.MODE) >= 0;
});

function updateTitleAndDescription(name, description) {
  document.title = name || "Account";
  const metaDescription = document.querySelector("meta[name='description']");
  if (metaDescription) {
    metaDescription.setAttribute("content", description || "");
  }
}

watch(() => [accountStore.current.name, accountStore.current.description], ([newName, newDescription]) => {
  updateTitleAndDescription(newName, newDescription);
});

</script>
<style></style>